import {
  inject,
  Injectable,
  PLATFORM_ID,
  RendererFactory2,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class GlobalClickService {
  private rendererFactory = inject(RendererFactory2);
  private platformId = inject(PLATFORM_ID);
  private renderer = this.rendererFactory.createRenderer(null, null);

  private lastClickedElement: HTMLElement | null = null;
  private lastClickTime = 0;
  private readonly THROTTLE_TIME = 1000; // 1 second

  init(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    // Use a capturing listener to intercept the event before it reaches sub-elements/components
    document.addEventListener(
      'click',
      (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        const button = target.closest(
          'button, p-button, .p-button'
        ) as HTMLElement;

        if (!button) {
          return;
        }

        const now = Date.now();

        // Check if the button was clicked recently
        if (
          this.lastClickedElement === button &&
          now - this.lastClickTime < this.THROTTLE_TIME
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        // Update state for next click
        this.lastClickedElement = button;
        this.lastClickTime = now;
      },
      { capture: true }
    );
  }
}
